import React, {useContext, useEffect} from 'react';
import '../sass/ResultModal.sass'
import ReactLoading from 'react-loading';
import {AuthContext} from "../../../../context/AuthContext";
import {useHttp} from "../../../../hooks/http.hook";
import {observer} from "mobx-react";
import PatientPageStore from "../Store/PatientPageStore";
import Modal from "../../../../components/Modal";


const ResultModal = observer(() => {
    const {request} = useHttp()
    const {token, userId} = useContext(AuthContext)
    const baseURL = process.env.REACT_APP_BASE_URL

    const getResultImage = async () => {

        const url = `${baseURL}/api/v2/patients/${userId}/results/${PatientPageStore.resultModal.resultId}  `
        const requestData = {method: "GET", body: null, bearer: {Authorization: `Bearer ${token?.token}`}}

        const {data} = await request(url, requestData.method, requestData.body, requestData.bearer)
            .then(async r => {
                const url2 = url + `?image=${r.data.data[0].imageId}`
                return request(url2, requestData.method, requestData.body, requestData.bearer)
            })
        return data.data[0].image
    }

    useEffect(() => {
        getResultImage()
            .then(image => {
                PatientPageStore.setResultModelImage(image)
            })
    }, [])

    return (
        <Modal>
            <div className="close-icon" onClick={() => {
                PatientPageStore.closeResultModal()
            }}>
                <i className="fas fa-times"/>
            </div>

            {PatientPageStore.resultModal.image === '' ?
                <ReactLoading type={'spin'} color='#fff' height={100} width={100}/> :
                <img className={'fade-in-fwd img'} src={PatientPageStore.resultModal.image} height={'100%'} alt={'1'}/>}
        </Modal>
    );
})

export default ResultModal;